import Vue from "vue";
import axiosBase from "axios";
import qs from "qs";
import { HTTP_SUCCESS, URL_PATH } from "../config/config";
import * as Api from "@/api/constant_api.js";

const axios = axiosBase.create({
  baseURL: URL_PATH,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept:
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9"
  }
});
// axios.defaults.withCredentials = true
let vue = new Vue();

const common = {
  cus_id: ""
};

function relogin() {
  // localStorage.removeItem('userInfo')
  // vue.$nextTick(() => {
  //   vue.$router.push('/login')
  // })
}

function rejected(err) {
  if (err.message === "Network Error") {
    vue.$message.error(err.message);
    relogin();
  }

  throw new Error(err);
}

/**
 * 异常响应
 * @param {*} data
 */
// function errorResponse(data) {
//   console.log(JSON.stringify(data));
//   vue.$message.error(data.Msg);
//   switch (data.Code) {
//     case 1003:
//     case 102:
//       localStorage.setItem("token", "");
//       if (vue.$route.path != "/") vue.$router.push("/");
//       break
//     case 1009:  // 用户无权限
//       break
//   }
// }

var timeOut = null;
function switchError(data) {
  if (timeOut) clearTimeout(timeOut);
  timeOut = setTimeout(function() {
    vue.$message({
      message: data.Msg,
      type: "error",
      duration: 2000,
      onClose: function() {
        switch (data.Code) {
          case 1003:
          case 1011: // 用户已禁用
          case 1002: // 用户不存在
          case 102:
            if (localStorage.getItem("token")) {
              loginout();
            }
            // localStorage.removeItem("token");
            // if (vue.$route.path != "/") {
            //   // vue.$router.push("/");
            //   loginout();
            // }
            break;
          // case 1009:  // 用户无权限
          //   break
        }
        console.log("switchError");
      }
    });
    // loginout();
  }, 500);
}

/**
 * 异常响应
 * @param {*} data
 */
function errorResponse(data) {
  console.log(JSON.stringify(data));
  switchError(data); // 同时多个接口返回异常处理
  if (localStorage.getItem("token")) {
  } else {
    vue.$router.push("/");
  }
}

function fulfilled(data) {
  if (data.status == HTTP_SUCCESS) {
    if (data.data.Code == 0) {
      return data;
    } else {
      errorResponse(data.data);
    }
  } else {
    console.log(data);
    // throw new Error(data.data.text)
  }
}

function post(url, params) {
  console.log(url + " --->  " + JSON.stringify(params));
  return axios
    .post(URL_PATH + url, encode(params, true))
    .then(fulfilled)
    .catch(rejected);
}

function post_(url, params) {
  console.log(url + " --->  " + JSON.stringify(params));
  return axios
    .post(URL_PATH + url, encode(params, true), { responseType: "arraybuffer" })
    .then(fulfilled)
    .catch(rejected);
}

function post2(url, params) {
  // if (requestIntercept()) return;
  params.forEach((value, key) => {
    console.log(" %s:  %s", key, value);
  });
  return axios
    .post(URL_PATH + url, params)
    .then(fulfilled)
    .catch(rejected);
}

function get(url, params) {
  // console.log(url + " --->  " + JSON.stringify(params));
  return axios
    .get(URL_PATH + url, { params: params })
    .then(fulfilled)
    .catch(rejected);
}

const api = {
  getImgVerify: params => get(Api.api_getImgVerify, params),
  login: params => post(`api/adminLogin/login`, params),
  autoLogin: params => post(`api/adminLogin/autoLogin`, params),
  bindAisInfoFieldArr: params => get(Api.api_bindAisInfoFieldArr, params),
  getNav: params => get(Api.api_getNav, params),
  getAisInfo: params => post(Api.api_getAisInfo, params), // 获取全部校友数据
  getAisEducation: params => post(`api/adminIndex/getAisEducation`, params), // 获取深造信息列表
  getAisJobInfos: params => post(`api/adminIndex/getAisJobInfo`, params), // 获取校友工作列表
  getAisJournal: params => post(`api/adminIndex/getAisJournal`, params), // 获取捐助列表
  getAisHonor: params => post(`api/adminIndex/getAisHonor`, params), // 获取荣誉列表
  updateAisRemark: params => post(`api/adminUpdate/updateAisRemark`, params), // 修改用户基本信息备注
  updateAisLabel: params => post(`api/adminUpdate/updateAisLabel`, params), // 修改用户基本信息备注
  updateStudentsByYear: params => get(Api.api_updateStudentsByYear, params), // 根据学年从si系统批量导入或更新学生信息
  updateStudentOne: params => get(Api.api_updateStudentOne, params), // 根据学号将SI系统信息导入或更新到学生基本信息表

  getApplyLog: params => post(Api.api_getApplyLog, params), // 获取校友申请邮箱记录（分页式）
  getEmailRemark: params => get(Api.api_getEmailRemark, params), // 获取邮箱得登录提示
  updateEmailRemark: params => post(Api.api_updateEmailRemark, params), // 更新校友邮箱登录提示

  apiVerify: params => post(Api.api_apiVerify, params), // 接口权限验证
  resetPasswdVerify: params => get(Api.api_resetPasswdVerify, params), // 重置管理员密码接口权限验证
  updateAdminUserVerify: params => get(Api.api_updateAdminUserVerify, params), // 重置管理员密码接口权限验证
  adminUserList: params => get(Api.api_adminUserList, params), // 管理员列表
  createAdminUser: params => post(Api.api_createAdminUser, params), // 新增一名管理员
  resetPasswd: params => post(Api.api_resetPasswd, params), // 重置管理员密码
  updateAdminUser: params => post(Api.api_updateAdminUser, params), // 编辑管理员信息
  delAdminUser: params => post(Api.api_delAdminUser, params), // 删除管理员信息
  apiList: params => get(Api.api_apiList, params), // 接口列表
  powerTemplateList: params => get(Api.api_powerTemplateList, params), // 角色模板列表
  createPowerTemplate: params => post(Api.api_createPowerTemplate, params), // 创建角色模板
  updatePowerTemplate: params => post(Api.api_updatePowerTemplate, params), // 更新角色模板
  delPowerTemplate: params => post(Api.api_delPowerTemplate, params), // 删除角色模板

  getAisInfoById: params => get(Api.api_getAisInfoById, params), // 通过id获取用户信息
  getAishoto: params => get("api/adminIndex/getAisInfoPhotoUrlById", params), // 获取校友头像
  getAisJobInfoById: params => get(`api/adminIndex/getAisJobInfoById`, params), // 获取工作信息
  getAisJournalMoneyTotal: params =>
    get(`api/adminIndex/getAisJournalMoneyTotal`, params), // 获取捐助金额
  downloadXlsx: params => post(Api.api_downloadXlsx, params), // 导出xlsx数据
  getAisEducationById: params =>
    get(`api/adminIndex/getAisEducationById`, params), // 通过校友id获取校友深造信息
  getAisJournalById: params => get(`api/adminIndex/getAisJournalById`, params), // 通过校友id获取校友捐助信息
  getAisHonorById: params => get(`api/adminIndex/getAisHonorById`, params), // 通过校友id获取校友荣誉信息
  updateAisById: (params, token) =>
    post(Api.api_updateAisById + `?token=` + token, params), // 编辑校友信息接口
  getEditToken: params => post(`api/verify/getEditToken`, params), // 获取一个编辑用户信息的token
  getOpLog: params => get(`api/adminRecordLog/getRecordLog`, params), // 操作日志
  logBackOff: params => get(`api/adminRecordLog/backOff`, params), // 操作日志回滚
  backOffImportLog: params =>
    get(`api/adminRecordLog/backOffImportLog`, params), // 操作日志回滚
  getRecordLogLists: params =>
    get(`api/adminRecordLog/getRecordLogLists`, params), // 获取操作日志单条记录的列表信息
  getColumnValue: params => get(`api/adminIndex/getColumnValue`, params), // 获取用户基本信息字段不同值接口
  getUserInfoCount: params => post(`api/adminIndex/getUserInfoCount`, params), // 获取信息数量
  updateInfoById: params => post(Api.api_updateInfoById, params), // 合并删除修改数据

  updateRepeatRate: params =>
    get(`api/adminRepeatRate/updateRepeatRate`, params), // 更新学生的工作信息，深造信息，捐助信息，荣誉信息重复率
  getRepeatSchedule: params =>
    get(`api/adminRepeatRate/getRepeatSchedule`, params), // 查询扫描更新校友相似度进度
  stopUpdateRepeat: params =>
    get(`api/adminRepeatRate/stopUpdateRepeat`, params), // 取消扫描更新校友相似度
  getRepeatInfo: params => get(`api/adminRepeatRate/getRepeatInfo`, params), // 查询重复率

  getBannerList: params => get(Api.api_bannerList, params),
  bannerInfo: params => get(Api.api_bannerInfo, params),
  delBanner: params => get(Api.api_delBanner, params),
  updateBanner: params => post2(Api.api_updateBanner, params),
  getBannerLink: params => get(Api.api_getBannerLink, params),

  getAssociationId: params => get(Api.api_getAssociationId, params),
  getActivityList: params => get(Api.api_activityList, params),
  updateActivity: params => post2(Api.api_updateActivity, params),
  activityInfo: params => get(Api.api_activityInfo, params),
  delActivity: params => get(Api.api_delActivity, params),

  newsList: params => get(Api.api_newsList, params),
  delNews: params => get(Api.api_delNews, params),
  updateNews: params => post2(Api.api_updateNews, params),
  newsInfo: params => get(Api.api_newsInfo, params),

  memorabiliaList: params => get(Api.api_memorabiliaList, params),
  delMemorabilia: params => get(Api.api_delMemorabilia, params),
  updateMemorabilia: params => post2(Api.api_updateMemorabilia, params),
  memorabiliaInfo: params => get(Api.api_memorabiliaInfo, params),

  associationList: params => get(Api.api_associationList, params),
  delAssociation: params => get(Api.api_delAssociation, params),
  updateAssociation: params => post2(Api.api_updateAssociation, params),
  associationInfo: params => get(Api.api_associationInfo, params),
  associationNewsList: params => get(Api.api_associationNewsList, params),
  associationActivityList: params =>
    get(Api.api_associationActivityList, params),
  associationImageList: params => get(Api.api_associationImageList, params),
  delAssociationImage: params => get(Api.api_delAssociationImage, params),
  addAssociationImage: params => post2(Api.api_addAssociationImage, params),
  associationJoinList: params => get(Api.api_associationJoinList, params),
  adminAppletsAssociationFileList: params => post(Api.api_adminAppletsAssociationFileList, params),
  adminAppletsAssociationFileCreateFolder: params => post(Api.api_adminAppletsAssociationFileCreateFolder, params),
  adminAppletsAssociationFileUpload: params => post2(Api.api_adminAppletsAssociationFileUpload, params),
  adminAppletsAssociationFileDelete: params => post(Api.api_adminAppletsAssociationFileDelete, params),
  adminAppletsAssociationFileDownload: params => post_(Api.api_adminAppletsAssociationFileDownload, params),
  adminAppletsAssociationFileDownloadBatch: params => post_(Api.api_adminAppletsAssociationFileDownloadBatch, params),
  adminAppletsAssociationFileMove: params => post(Api.api_adminAppletsAssociationFileMove, params),
  adminAppletsAssociationFileGetMovableFolderTree: params => post(Api.api_adminAppletsAssociationFileGetMovableFolderTree, params),
  adminAppletsAssociationFileRenameFolder: params => post(Api.api_adminAppletsAssociationFileRenameFolder, params),
  adminAppletsAssociationFileRename: params => post(Api.api_adminAppletsAssociationFileRename, params),
  adminAppletsAssociationTeamList: params => post(Api.api_adminAppletsAssociationTeamList, params),
  adminAppletsAssociationTeamRoleList: params => post(Api.api_adminAppletsAssociationTeamRoleList, params),
  adminAppletsAssociationTeamCreate: params => post(Api.api_adminAppletsAssociationTeamCreate, params),
  adminAppletsAssociationTeamUpdate: params => post(Api.api_adminAppletsAssociationTeamUpdate, params),
  adminAppletsAssociationTeamInfo: params => post(Api.api_adminAppletsAssociationTeamInfo, params),
  adminAppletsAssociationTeamDelete: params => post(Api.api_adminAppletsAssociationTeamDelete, params),
  adminAppletsAssociationTeamExport: params => post_(Api.api_adminAppletsAssociationTeamExport, params),

  associationNewInfo: params => get(Api.api_associationNewInfo, params),
  associationUpdateNews: params => post2(Api.api_associationUpdateNews, params),
  associationDelNews: params => get(Api.api_associationDelNews, params),

  associationActivityInfo: params =>
    get(Api.api_associationActivityInfo, params),
  associationUpdateActivity: params =>
    post2(Api.api_associationUpdateActivity, params),
  associationDelActivity: params => get(Api.api_associationDelActivity, params),

  dataAuthenticationList: params => get(Api.api_dataAuthenticationList, params),
  registeredMemberList: params => post(Api.api_registeredMemberList, params),
  faceAuthenticationList: params => get(Api.api_faceAuthenticationList, params),
  activationList: params => get(Api.api_activationList, params),
  activationInfo: params => get(Api.api_activationInfo, params),
  authenticationInfo: params => get(Api.api_authenticationInfo, params),
  registeredMember: params => get(Api.api_registeredMember, params),
  examineAuthenticationLog: params =>
    post(Api.api_examineAuthenticationLog, params),
  searchStudentNo: params => get(Api.api_searchStudentNo, params),
  searchRegisteredMember: params =>
    post(Api.api_searchRegisteredMember, params),
  execRegisteredMember: params => post(Api.api_execRegisteredMember, params),

  shopList: params => get(Api.api_shopList, params),
  updateShop: params => post2(Api.api_updateShop, params),
  shopInfo: params => get(Api.api_shopInfo, params),
  getRegion: params => get(Api.api_getRegion, params),
  shopTypeInfo: params => get(Api.api_shopTypeInfo, params),
  delShop: params => get(Api.api_delShop, params),
  uploadShopImage: params => post2(Api.api_uploadShopImage, params),
  shopTypeList: params => get(Api.api_shopTypeList, params),
  updateShopType: params => post2(Api.api_updateShopType, params),
  getParentList: params => post(Api.api_getParentList, params),
  delShopType: params => get(Api.api_delShopType, params),
  shopTypeTreeList: params => get(Api.api_shopTypeTreeList, params),
  updateShopRecruit: params => post(Api.api_updateShopRecruit, params),
  delShopRecruit: params => get(Api.api_delShopRecruit, params),
  waitReviewShop: params => get(Api.api_waitReviewShop, params),
  waitReviewShopInfo: params => get(Api.api_waitReviewShopInfo, params),
  shopRecruit: params => get(Api.api_shopRecruit, params),
  execReviewShopInfo: params => post(Api.api_execReviewShopInfo, params),

  welfareList: params => post(Api.api_welfareList, params),
  welfareInfo: params => get(Api.api_welfareInfo, params),
  updateWelfare: params => post2(Api.api_updateWelfare, params),
  delWelfare: params => get(Api.api_delWelfare, params),

  welfareRecruitList: params => post(Api.api_welfareRecruitList, params),
  welfareRecruitInfo: params => get(Api.api_welfareRecruitInfo, params),
  updateWelfareRecruit: params => post2(Api.api_updateWelfareRecruit, params),
  delWelfareRecruit: params => post(Api.api_delWelfareRecruit, params),
  campusVisitList: params => post(Api.api_adminAppletsWelfareCampusVisitList, params),
  campusVisitDetail: params => post(Api.api_adminAppletsWelfareCampusVisitDetail, params),
  campusVisitBlacklist: params => post(Api.api_adminAppletsWelfareCampusVisitBlacklist, params),
  campusVisitAddBlacklist: params => post(Api.api_adminAppletsWelfareCampusVisitAddBlacklist, params),
  campusVisitDelBlacklist: params => post(Api.api_adminAppletsWelfareCampusVisitDelBlacklist, params),
  paramSurveyLis: params => get(Api.api_paramSurveyList, params),

  donationList: params => post(Api.api_donationList, params),
  donationInfo: params => get(Api.api_donationInfo, params),
  updateDonation: params => post2(Api.api_updateDonation, params),
  delDonation: params => get(Api.api_delDonation, params),

  getJournalById: params => get(Api.api_getJournalById, params),
  getDonationInfo: params => get(Api.api_getDonationInfo, params),
  getAppletsDonationInfo: params => get(Api.api_getAppletsDonationInfo, params),
  updateDonationMail: params => post(Api.api_updateDonationMail, params),
  updateAisJournal: params => post(Api.api_updateAisJournal, params),

  updateIntegralMail: params => post(Api.api_updateIntegralMail, params),
  integralOrderInfo: params => post(Api.api_integralOrderInfo, params),
  integralOrderList: params => post(Api.api_integralOrderList, params),
  delIntegralProduct: params => post(Api.api_delIntegralProduct, params),
  uploadProductThumb: params => post2(Api.api_uploadProductThumb, params),
  updateIntegralProduct: params => post2(Api.api_updateIntegralProduct, params),
  integralProductInfo: params => get(Api.api_integralProductInfo, params),
  integralProductList: params => get(Api.api_integralProductList, params),
  integralAlumniList: params => get(Api.api_integralAlumniList, params),

  alumniNewPhotoList: params => get(Api.api_alumniNewPhotoList, params),
  waitReviewPhotoList: params => get(Api.api_waitReviewPhotoList, params),
  examineAlumniPhoto: params => post(Api.api_examineAlumniPhoto, params),
  updateAlumniPhotoStyle: params =>
    post(Api.api_updateAlumniPhotoStyle, params),
  getAlumniPhotoStyle: params => get(Api.api_getAlumniPhotoStyle, params),
  downloadPhoto: params => post(Api.api_downloadPhoto, params),

  agreementManagement: params => get(Api.api_agreementManagement, params),
  updateAgreementManagement: params =>
    post(Api.api_updateAgreementManagement, params),
  isAssociationAdmin: params => get(Api.api_isAssociationAdmin, params),
  getAssociationAdminList: params =>
    get(Api.api_getAssociationAdminList, params),

  getSurveyList: params => get(Api.api_surveyList, params), // 获取问卷列表
  editSurvey: params => get(Api.api_editSurvey, params), // 修改问卷状态
  delSurvey: params => post(Api.api_delsurvey, params), // 删除问卷
  importSheet: params => get(Api.api_importSheet, params), // 导入问卷
  surveyInfo: params => get(Api.api_surveyInfo, params), // 问卷详情
  surveyAudit: params => get(Api.api_surveyAudit, params), // 问卷审核
  answerList: params => get(Api.api_answerList, params), // 回收数据列表
  answerInfo: params => get(Api.api_answerInfo, params), // 问卷答案详情
  allowAnswer: params => post(Api.api_allowAnswer, params), // 问卷审核通过
  notAllowAnswer: params => post(Api.api_notAllowAnswer, params), // 问卷审核拒绝
  exportAnswerList: params => post(Api.api_exportAnswerList, params), // 问卷导出
  delAnswer: params => post(Api.api_delAnswer, params), // 问卷导出
  statisticsIndex: params => post(Api.api_statisticsIndex, params), // 数据分析表

  functionList: params => post(Api.api_functionList, params), // 小程序功能列表
  dataByFunction: params => post(Api.api_dataByFunction, params), // 某功能访问量
  dataByFunctionExport: params => get(Api.api_dataByFunctionExport, params), // 导出数据

  // // 导出功能
  // exportAisHonorList: params => post(Api.api_exportAisHonor, params), //问卷导出
  // exportAisEducationList: params => post(Api.api_exportAisEducation, params), //问卷导出
  // exportAisJobInfoList: params => post(Api.api_exportAisJobInfo, params), //问卷导出
  // exportAisJournalList: params => post(Api.api_exportAisJournal, params), //问卷导出

  startBuild: params => post(`start_build`, params),
  getProcess: params => post(`process`, params),

  wishesList: params => post(Api.api_WishesList, params), // 回忆列表
  wishesDetail: params => post(Api.api_WishesDetail, params), // 回忆详情
  wishesEdit: params => post2(Api.api_WishesEdit, params), // 新增、编辑回忆
  wishesDel: params => post(Api.api_WishesDel, params), // 删除回忆

  adminAppletsAssociationPhotoAlbumList: params => post(Api.api_adminAppletsAssociationPhotoAlbumList, params),
  adminAppletsAssociationPhotoCreateAlbum: params => post(Api.api_adminAppletsAssociationPhotoCreateAlbum, params),
  adminAppletsAssociationPhotoEditAlbum: params => post(Api.api_adminAppletsAssociationPhotoEditAlbum, params),
  adminAppletsAssociationPhotoDeleteAlbum: params => post(Api.api_adminAppletsAssociationPhotoDeleteAlbum, params),
  adminAppletsAssociationPhotoAlbumDetail: params => post(Api.api_adminAppletsAssociationPhotoAlbumDetail, params),
  adminAppletsAssociationPhotoUploadChunk: params => post(Api.api_adminAppletsAssociationPhotoUploadChunk, params),
  adminAppletsAssociationPhotoMergeChunks: params => post(Api.api_adminAppletsAssociationPhotoMergeChunks, params),
  adminAppletsAssociationPhotoDeletePhoto: params => post(Api.api_adminAppletsAssociationPhotoDeletePhoto, params),
  adminAppletsAssociationPhotoEditPhoto: params => post(Api.api_adminAppletsAssociationPhotoEditPhoto, params),
  adminAppletsAssociationPhotoSortPhoto: params => post(Api.api_adminAppletsAssociationPhotoSortPhoto, params),

  videoList: params => post(Api.api_VideoList, params) // 视频列表
};

Object.defineProperty(api, "_setApp", {
  value(app) {
    vue = app;
  }
});

export function encode(params, isPost) {
  common.cus_id = localStorage.getItem("cus_id");
  if (common.cus_id) {
    params = Object.assign({}, common, params);
  }
  params = isPost ? qs.stringify(params) : params;

  return params;
}

export function uploadEncode(params) {
  const cus_id = localStorage.getItem("cus_id");
  params.append("cus_id", cus_id);
  return params;
}

// 接口权限验证
export function verifyApi(url, callback) {
  api
    .apiVerify({
      token: localStorage.getItem("token"),
      url: URL_PATH + url
    })
    .then(({ data }) => {
      callback(true);
    })
    .catch(({ error }) => {
      callback(false);
    });
}

export function loginout() {
  localStorage.removeItem("token");
  vue.$router.push("/");
  location.reload();
}

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js